/* ==============================
  Aquariumer Plant Hub
  Common JS
============================== */

document.addEventListener('DOMContentLoaded', function () {
  var isLoggedIn = Boolean(window.aqIsLoggedIn);
  var customerTags = Array.isArray(window.aqCustomerTags) ? window.aqCustomerTags : [];

  var isFreeMember = customerTags.indexOf('free-member') !== -1;
  var isPaidMember = customerTags.indexOf('paid-member') !== -1;

  document.documentElement.classList.toggle('aq-is-logged-in', isLoggedIn);
  document.documentElement.classList.toggle('aq-is-free-member', isFreeMember);
  document.documentElement.classList.toggle('aq-is-paid-member', isPaidMember);

  function canView(required) {
    if (required === 'login') {
      return isLoggedIn;
    }

    if (required === 'free') {
      return isFreeMember || isPaidMember;
    }

    if (required === 'paid') {
      return isPaidMember;
    }

    return false;
  }

  document.querySelectorAll('[data-aq-member-content]').forEach(function (content) {
    var required = content.getAttribute('data-aq-member-content');

    if (canView(required)) {
      content.classList.add('is-unlocked');
    }
  });

  document.querySelectorAll('[data-aq-member-gate]').forEach(function (gate) {
    var required = gate.getAttribute('data-aq-member-gate');

    if (canView(required)) {
      gate.classList.add('is-hidden');
    }
  });

  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (event) {
      var targetId = anchor.getAttribute('href');

      if (!targetId || targetId === '#') return;

      var target = document.querySelector(targetId);

      if (!target) return;

      event.preventDefault();

      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
  });
});